import { VenueId } from '../../venues/venues.types';

export enum SubscriptionTier {
	Free = 'free',
	Paid = 'paid',
}

export enum AccessLevel {
	Full = 'full',
	Subset = 'subset',
	None = 'none',
}

export type VenueAccessRow = Partial<Record<VenueId, AccessLevel>>;
export type VenueAccessByTier = Record<SubscriptionTier, VenueAccessRow>;
export type VenueAccessMatrix = Record<number, VenueAccessByTier>;
